import { render, staticRenderFns } from "./PointLink.vue?vue&type=template&id=1dbb8170&scoped=true"
import script from "./PointLink.vue?vue&type=script&lang=js"
export * from "./PointLink.vue?vue&type=script&lang=js"
import style0 from "./PointLink.vue?vue&type=style&index=0&id=1dbb8170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbb8170",
  null
  
)

export default component.exports